import { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { AtomicBlockUtils, EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { useEditor } from '../../hooks/useEditor';
import moment from 'moment';
import useFormEditorState from '../../state/formeditor.state';
import { Controller } from 'react-hook-form';
import classNames from 'classnames';
import { AlurkerjaInputType } from '../../types/InputType';
import { watch } from 'fs';

interface WysiwygProps {
  props: AlurkerjaInputType
}

export const Wysiwyg = ({ props }: WysiwygProps) => {

  const { item: item, form: { control, setValue ,  getValues } } = props;

  const defaultValue = getValues(item.name);

  const [wysiwygReady, setWysiwygReady] = useState(false);
  const { uploadImageForEditor } = useEditor();
  const { axiosInstance } = useFormEditorState();

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const onEditorStateChange = (editorState: EditorState) => {
    setEditorState(editorState);
  };

  useEffect(() => {
    if (editorState.getCurrentContent().hasText()) {
      const content = draftToHtml(convertToRaw(editorState.getCurrentContent()));
      setValue(item.name, content);
    }
  }, [editorState]);

  useEffect(() => {
    if (wysiwygReady) return;

    if (defaultValue) {
      console.log('defaultValue', defaultValue);
      const contentBlock = htmlToDraft(defaultValue);
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const newEditorState = EditorState.createWithContent(contentState);

      setEditorState(newEditorState);
      setWysiwygReady(true);
    }
  }, [defaultValue]);

  function getBase64(file: any, success: any) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      success(reader.result);
    };
  }

  const handlePastedFiles = (files: any) => {
    const formData = new FormData();
    formData.append(
      'upload',
      files[0],
      'image' + moment().format('DDMMYYYHHmmSS') + '-' + Math.floor(Math.random() * 1000000000),
    );

    return axiosInstance
      .post('https://n8n.merapi.javan.id/webhook/e1cc9b23-6595-4bb5-bd28-da934b5d26b2', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((data: any) => {
        getBase64(files[0], (res: any) => {
          insertImage(data.data.url, res);
        });
      });
  };

  const Media = (props: any) => {
    const entity = props.contentState.getEntity(props.block.getEntityAt(0));
    const { base64 } = entity.getData();
    const type = entity.getType();

    let media;
    if (type === 'IMAGE') {
      media = <img src={base64} />;
    }

    return media;
  };

  function mediaBlockRenderer(block: any) {
    if (block.getType() === 'atomic') {
      return {
        component: Media,
        editable: false,
      };
    }

    return null;
  }

  const insertImage = (url: string, base64: string) => {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity('IMAGE', 'IMMUTABLE', { src: url, base64: base64 });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
    setEditorState(AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, url));
  };

  const handleEditorDrop = (e: any) => {
    e.preventDefault();

    if (e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files;

      if (file[0].type.startsWith('image')) {
        handlePastedFiles(file);
      }
    }
  };

  return (

    <div>
      <label
        className={classNames('font-medium text-sm', {
          'after:content-["*"] after:text-red-400 after:text-sm': item.constraints?.required,
        })}
        htmlFor={item.name}
      >
        {item.label.en}
      </label>
      <Controller
        name={item.name}
        control={control}
        rules={{
          required: item.constraints?.required ? 'This field is required' : false
        }}
        render={({ fieldState, field }) => {
          return (
            <div data-testid="wysiwyg-editor" onDrop={handleEditorDrop}>
              <Editor
                wrapperClassName="border"
                editorState={editorState}
                editorClassName="px-4 min-h-[100px]"
                onEditorStateChange={onEditorStateChange}
                readOnly={item.disabled}
                toolbar={{
                  image: {
                    uploadCallback: (file: File) => uploadImageForEditor(file, true),
                    alt: { present: true, mandatory: true },
                  },
                }}
              />
              {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>} 
            </div>
          );
        }}
      ></Controller>
    </div>
  );
};



